export default "__VITE_ASSET__05513351__"